<svg class="landing-gem" viewBox="0 0 40 40" aria-hidden="true">
  @for (facet of rotation() | landingGemFacets; track $index) {
    <polygon
      class="landing-gem__facet"
      [attr.points]="facet.points"
      [attr.fill]="facet.fill"
    />
  }
</svg>
